import {
  Badge,
  Box,
  Card,
  HStack,
  Heading,
  Progress,
  Text,
  VStack,
} from "@chakra-ui/react"

interface DifficultyIndicatorProps {
  difficultyScore: number
  difficultyLevel: "Easy" | "Medium" | "Hard"
}

export default function DifficultyIndicator({
  difficultyScore,
  difficultyLevel,
}: DifficultyIndicatorProps) {
  const colorScheme = {
    Easy: "green",
    Medium: "yellow",
    Hard: "red",
  }[difficultyLevel]

  return (
    <Card.Root h="full">
      <Card.Body>
        <Heading size="md" mb={4}>
          Difficulty
        </Heading>
        <VStack align="stretch" gap={4}>
          <HStack justify="space-between">
            <Text fontSize="2xl" fontWeight="bold">
              {difficultyScore.toFixed(1)}%
            </Text>
            <Badge colorScheme={colorScheme} fontSize="md" px={3} py={1}>
              {difficultyLevel}
            </Badge>
          </HStack>

          <Box>
            <Progress.Root
              value={difficultyScore}
              colorPalette={colorScheme}
              size="lg"
              borderRadius="md"
            >
              <Progress.Track>
                <Progress.Range />
              </Progress.Track>
            </Progress.Root>
          </Box>

          <Text fontSize="sm" color="gray.600">
            {difficultyLevel === "Easy" &&
              "Most students answer correctly (>70%)"}
            {difficultyLevel === "Medium" && "Moderate difficulty (40-70%)"}
            {difficultyLevel === "Hard" && "Challenging question (<40%)"}
          </Text>
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}
